<script lang="ts">
  import { Link } from "svelte-navigator";
  import { useLocation } from "svelte-navigator";

  export let to: string;
  export let textColor: string = "#a7b0b5";
  export let activeTextColor: string = "#0e0121";
  export let hoverTextColor: string = "#0e0121";
  export let disableTextColor: string = "#FFFFFF40";
  export let disabled: boolean = false;
  export let underlineOnHover: boolean = false;

  const location = useLocation();

  $: path = $location.pathname;
  $: activeStyle = to.length > 1 && path.indexOf(to) === 0;
</script>

<div
  class:disabled
  class:underline-on-hover={underlineOnHover}
  class:active={activeStyle}
  style="--link-color: {textColor}; --link-active-color: {activeTextColor}; --link-hover-color: {hoverTextColor}; --link-disabled-color: {disableTextColor}"
>
  <Link {to} {...$$restProps}><slot /></Link>
</div>

<style lang="postcss">
  div {
    color: var(--link-color);
    font-weight: 500;
    letter-spacing: 0.05em;
  }

  div :global(a[aria-current]),
  div.active :global(a) {
    color: var(--link-active-color);
    font-weight: 600;
    text-decoration: none !important;
  }

  div:hover {
    color: var(--link-hover-color);
  }

  div.disabled {
    color: var(--link-disabled-color) !important;
    pointer-events: none;
  }

  div:not(.disabled).underline-on-hover:hover :global(a:not([aria-current])) {
    text-decoration: underline;
  }
</style>
